import { useEffect, useState } from "react";
import { testSql } from "./TestFunctions";
import { Tooltip } from "@mui/material";
import { useSnackbar } from "src/context/SnackbarContext";

export default function TestSql_light() {
  const { openSnackbar } = useSnackbar();
  const [color, setColor] = useState("gray");
  const [pingMs, setPingMs] = useState(0);
  const [isError, setIsError] = useState(false);

  // Function to show a snackbar notification
  const showSnackbar = (title, message, severity) => {
    openSnackbar({
      open: true,
      title,
      message,
      severity,
    });
  };

  // Function to handle the API response
  const handleApiResponse = (pingMs) => {
    if (pingMs > 0) {
      setColor("green");
      setPingMs(pingMs.toFixed(0));
      if (isError) {
        showSnackbar("Yhteys palautui", "Yhteys palvelimeen palautui onnistuneesti.", "success");
        setIsError(false);
      }
    } else {
      setColor("red");
      setPingMs(pingMs);
      showSnackbar(
        "Yhteysvirhe",
        "Palvelimeen ei saatu yhteyttä. Tarkista internet-yhteys ja yritä uudelleen.",
        "error"
      );
      setIsError(true);
    }
  };

  // Function to handle API errors
  const handleApiError = (error) => {
    console.error("API test failed:", error);
    setColor("red");
    showSnackbar(
      "Virhe",
      "Palvelimeen ei saatu yhteyttä. Tarkista internet-yhteys ja yritä uudelleen.",
      "error"
    );
  };

  useEffect(() => {
    let mounted = true;
    let intervalId;

    // Function to test the API and update the state
    const _testApi = async () => {
      try {
        let pingMs = await testSql();
        if (mounted) {
          handleApiResponse(pingMs);
          if (pingMs > 0) clearInterval(intervalId);
        }
      } catch (error) {
        if (mounted) handleApiError(error);
      }
    };

    // Initial API test and set interval for repeated tests
    _testApi();
    intervalId = setInterval(_testApi, 1000);

    // Cleanup function to clear the interval and set mounted to false
    return () => {
      mounted = false;
      clearInterval(intervalId);
    };
  }, []);

  return (
    <Tooltip
      disableInteractive
      title={"SQL " + (pingMs > 0 ? `ping: ${pingMs} ms` : "") + (pingMs === null ? " virhe" : "")}
      placement="top">
      <svg height="10" width="10">
        <circle cx="5" cy="5" r="4" stroke={color} strokeWidth="1" fill={color} />
      </svg>
    </Tooltip>
  );
}
